import { useState } from 'react';
import ContactModal from './ContactModal';

export default function Footer() {
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <>
    <footer className="relative overflow-hidden" data-testid="site-footer">
      <div className="relative bg-gradient-to-br from-void via-grape to-orchid text-paper">
        {/* dot grid */}
        <div className="absolute inset-0 dot-grid opacity-25 pointer-events-none" />
        {/* violet blooms */}
        <div className="absolute -left-40 -top-20 w-[500px] h-[500px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(closest-side, rgba(224,170,255,0.35), transparent 70%)' }} />
        <div className="absolute -right-40 bottom-0 w-[600px] h-[600px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(closest-side, rgba(157,78,221,0.35), transparent 70%)' }} />

        <div className="relative mx-auto max-w-[1440px] px-6 md:px-12 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-24">
            <div className="md:col-span-6">
              <div className="mono text-[10px] uppercase tracking-[0.3em] text-lavender mb-6">(∞) — End of file</div>
              <p className="serif text-2xl md:text-3xl leading-tight max-w-md">
                Own the voice. This is land I own — not an apartment rented from an algorithm.
              </p>
            </div>
            <div className="md:col-span-3">
              <div className="mono text-[10px] uppercase tracking-[0.3em] text-lavender mb-4">Elsewhere</div>
              <ul className="space-y-2 mono text-sm">
                <li><a data-testid="footer-linkedin" href="https://linkedin.com/in/eileentadeo" target="_blank" rel="noreferrer" className="hover:text-lavender">LinkedIn ↗</a></li>
                <li>
                  <button
                    type="button"
                    data-testid="footer-email"
                    onClick={() => setContactOpen(true)}
                    className="hover:text-lavender bg-transparent p-0 text-left mono text-sm"
                  >
                    Email ↗
                  </button>
                </li>
                <li><a data-testid="footer-notes" href="#field-notes" className="hover:text-lavender">Field notes ↓</a></li>
              </ul>
            </div>
            <div className="md:col-span-3">
              <div className="mono text-[10px] uppercase tracking-[0.3em] text-lavender mb-4">Locations</div>
              <ul className="space-y-2 mono text-sm">
                <li>Berlin, DE</li>
                <li>Montréal, CA</li>
                <li>&nbsp;</li>
                <li className="text-lavender">51.5074° / 13.4050°</li>
              </ul>
            </div>
          </div>

          {/* Giant wordmark */}
          <div className="border-t border-paper/25 pt-10">
            <h2 className="serif leading-[0.85] text-[18vw] md:text-[14vw] tracking-[-0.02em] text-paper" data-testid="footer-wordmark">
              Eileen <span className="italic">Tadeo</span>.
            </h2>
          </div>

          <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mono text-[11px] text-paper/60">
            <div>© {new Date().getFullYear()} Eileen Tadeo · Potato Moon · A door, not a plea.</div>
            <div className="flex items-center gap-4">
              <span>Set in Fraunces &amp; IBM Plex Mono.</span>
              <span>·</span>
              <span>Built like a case study.</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
      <ContactModal
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        project="general"
        title="Drop me a note."
      />
    </>
  );
}
